import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostListener } from '@angular/core';


@Component({
	selector: 'atr-root',
	templateUrl: './app.component.html',
	styleUrls: ['./app.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {


	@HostListener('window:resize', ['$event'])
	onResize() {
		this.cdr.markForCheck();
	}

	constructor(private cdr: ChangeDetectorRef) {}
}
